import {
  ADD_DEVICE_FORM,
  ADD_MASTER_DEVICE_FORM,
  ASSIGN_DEVICE_ERROR,
  ASSIGN_DEVICE_PENDING,
  ASSIGN_DEVICE_SUCCESS,
  CLEAR_ASSIGN_DEVICE_ERROR,
  CLEAR_CREATE_DEVICE_ERROR,
  CLEAR_CREATE_MASTER_DEVICE_ERROR,
  CLEAR__DEVICE_DELETE_ERROR,
  CLEAR__DEVICE_LIST_ERROR,
  CLOSE_ASSIGN_DEVICE_MODAL,
  CLOSE_CREATE_DEVICE_MODAL,
  CLOSE_CREATE_MASTER_DEVICE_MODAL,
  CLOSE_DEVICE_CYCLE_MODAL,
  CLOSE_DEVICE_LOG_MODAL,
  CREATE_DEVICE_ERROR,
  CREATE_DEVICE_PENDING,
  CREATE_DEVICE_SUCCESS,
  CREATE_MASTER_DEVICE_ERROR,
  CREATE_MASTER_DEVICE_PENDING,
  CREATE_MASTER_DEVICE_SUCCESS,
  DEFAULT_MASTER_DEVICE_SERIAL_NO,
  DEVICES_LIST_ERROR,
  DEVICE_CYCLE_ERROR,
  DEVICE_DELETE_CONFIRMATION_CLOSE,
  DEVICE_DELETE_CONFIRMATION_OPEN,
  DEVICE_DELETE_ERROR,
  DEVICE_LOG_ERROR,
  GET_DEVICE_CYCLE_PENDING,
  GET_DEVICE_CYCLE_SUCCESS,
  GET_DEVICE_LOG_PENDING,
  GET_DEVICE_LOG_SUCCESS,
  MASTER_DEVICES_LIST_ERROR,
  OPEN_ASSIGN_DEVICE_MODAL,
  OPEN_CREATE_DEVICE_MODAL,
  OPEN_CREATE_MASTER_DEVICE_MODAL,
  OPEN_DEVICE_CYCLE_MODAL,
  OPEN_DEVICE_LOG_MODAL,
  SET_ASSIGN_DEVICE,
  SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC,
  SET_DEVICES_LIST,
  SET_DEVICES_PENDING,
  SET_DEVICE_CYCLE,
  SET_DEVICE_DELETE_DATA,
  SET_DEVICE_DELETE_PENDING,
  SET_DEVICE_LIST_OPTION,
  SET_DEVICE_LOG,
  SET_LAST_SERIAL_NO,
  SET_MASTER_DEVICES_LIST,
  SET_MASTER_DEVICES_PENDING,
  SET_MASTER_DEVICE_KEY,
  SET_SELECTED_DEVICE_ID,
  SET_SELECTED_DEVICE,
  SET_UNASSIGNABLE_GROUPS_LIST_ASYNC,
  SET_UNASSIGNED_DEVICE_LIST_ASYNC,
  CLEAR_DEVICE_LOG,
} from "../device/actionTypes";
import {
  getToken,
  modifyCategoryList,
  modifyDevicesList,
  modifyGroupsList,
} from "../../helper/common";
import agent from "../services/agent";
import { MANUFACTURER, SUPER_ADMIN } from "../users/role.constants";
import { showSnackbarStatus } from "../snackbar/actions";
import { clearForm } from "../form/actions";
import trimmedValues from "../../helper/trimmer";
import moment from "moment";

//-------------------------DEVICE-CREATE----------------------------------------
export const openCreateDeviceModal = () => ({
  type: OPEN_CREATE_DEVICE_MODAL,
});

export const closeCreateDeviceModal = () => ({
  type: CLOSE_CREATE_DEVICE_MODAL,
});

export const createDevicePending = () => ({
  type: CREATE_DEVICE_PENDING,
});

export const createDeviceSuccess = () => ({
  type: CREATE_DEVICE_SUCCESS,
});

export const createDeviceError = (errorMessage) => ({
  type: CREATE_DEVICE_ERROR,
  payload: { errorMessage },
});

export const clearCreateDeviceError = () => ({
  type: CLEAR_CREATE_DEVICE_ERROR,
});

export const addDeviceForm = (Adddeviceform) => ({
  type: ADD_DEVICE_FORM,
  payload: { Adddeviceform }
})

const setLastSerialNumber = (lastSerialNo) => ({
  type: SET_LAST_SERIAL_NO,
  payload: { lastSerialNo },
});
export const getLastSerialNumber = () => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getLastSerialNumber(accessToken)
      .then((serialNo) => {
        dispatch(setLastSerialNumber(serialNo));
      })
      .catch((err) => {
        console.log("getLastSerialNumber server error", err);
      });
  });
};

const formatAddDeviceKeys = (noOfDevices, lastSerialNo) => {
  var deviceKeys = [];
  if (!noOfDevices) return deviceKeys;
  else if (lastSerialNo === null || lastSerialNo === undefined)
    return deviceKeys;
  var i = lastSerialNo + 1;
  while (noOfDevices > 0) {
    deviceKeys.push(i);
    i++;
    noOfDevices--;
  }

  return deviceKeys;
};

export const addDevices = (lastSerialNo) => (dispatch, getState) => {
  const currentState = getState();
  const { form } = currentState;
  const { formAddDevice } = form && form.form;
  const data = {
    ...formAddDevice.formAddDevice1,
    ...formAddDevice.formAddDevice2,
    ...formAddDevice.formAddDevice3,
  }
  const { login } = currentState;
  const { currentProfile } = login;
  const orgId = currentProfile.roles[0].roleKey !== SUPER_ADMIN ? currentProfile.roles[0].orgId : data.new_user_organisation.value;
  if (!data) {
    dispatch(createDeviceError("Please fill required details."));
    return;
  }

  const deviceKeys = formatAddDeviceKeys(data.noOfDevices, lastSerialNo);
  if (deviceKeys.length < 1) {
    dispatch(assignDeviceError("Please select no of devices or Unable to fetch the last serial no."));
    return;
  }

  if (!data.new_product) {
    dispatch(createDeviceError("Please select Product name."));
    return;
  }
  const addDeviceData = {
    name: data.new_product && data.new_product.value,
    description: data.description,
    orgId: orgId,
    deviceKeys: deviceKeys,
    sensorType: data.sensorType,
    hardwareVersion: data.hardwareVersion,
    firmwareVersion: data.firmwareVersion,
    numOfSwitches: data.numOfSwitches,
    modelNo: data.modelNo,
    sessionId: data.sessionId,
    amcStartDate: data.amcStartDate,
    amcEndDate: data.amcEndDate,
    amcStatus: data.amcStatus,
    SubscriptionValidate: data.SubscriptionValidate,
  };

  const values = trimmedValues(addDeviceData);
  dispatch(createDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.addDevices(accessToken, values)
      .then(() => {
        dispatch(createDeviceSuccess());
        dispatch(closeCreateDeviceModal());
        dispatch(showSnackbarStatus("Devices added successfully"));

      })
      .catch((err) => {
        if (err && err.response) {
          const { message } = err.response.body;
          dispatch(createDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createDeviceError(message));
        }
        console.log("Add devices server error", err);
        dispatch(closeCreateDeviceModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

//-------------------------DEVICE-LIST----------------------------------------
export const clearDeviceListError = () => ({
  type: CLEAR__DEVICE_LIST_ERROR,
});

export const setDevicesPending = () => ({
  type: SET_DEVICES_PENDING,
});

const setDevicesList = (devicesOdata) => ({
  type: SET_DEVICES_LIST,
  payload: { devicesOdata },
});

const deviceListError = (errorMessage) => ({
  type: DEVICES_LIST_ERROR,
  payload: { errorMessage },
});

export const getDevicesList = (currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedByUserEmail, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setDevicesPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.getDevices(accessToken, currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchIsReturned, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedByUserEmail, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder)
      .then((devicesList) => {
        dispatch(setDevicesList(devicesList));
        return Promise.resolve();
      })
      .catch((err) => {
        console.log("getDevices server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        return Promise.resolve();
      });
  });
};

export const getLatestDevices = (currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setDevicesPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.getLatestDevices(accessToken, currentPage, pagesize, searchDeviceKey, searchUid, searchModelNo, searchName, searchHardwareVersion, searchFirmwareVersion, searchOrgName, searchAssignedUserDisplayName, searchAssignedUserEmail, searchAssignedUserRoleName, searchIsAssigned, searchIsActive, searchIsDeleted, searchEndCustomerName, searchEndCustomerEmail, searchroomName, searchCreatedDateTime, sortDirection, sortOrder)
      .then((devicesList) => {
        dispatch(setDevicesList(devicesList));
        return Promise.resolve();
      })
      .catch((err) => {
        console.log("getDevices server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        return Promise.resolve();
      });
  });
};

export const exportData = () => (dispatch, getState) => {
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.exportData(accessToken)
      .then((responseData) => {
        if (responseData) {
          return Promise.resolve(responseData["value"]);
        }
      })
      .catch((err) => {
        console.log("device data export server error", err);
      });
  });
};

export const exportLatestDevices = () => (dispatch) => {
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.exportLatestDevice(accessToken)
      .then((responseData) => {
        if (responseData) {
          return Promise.resolve(responseData["value"]);
        }
      })
      .catch((err) => {
        console.log("device data export server error", err);
      });
  });
};



//-------------------------DEVICE-LIFE-CYCLE-------------------------------------
export const openDevicesCycleModal = () => ({
  type: OPEN_DEVICE_CYCLE_MODAL,
});

export const closeDevicesCycleModal = () => ({
  type: CLOSE_DEVICE_CYCLE_MODAL,
});
export const setDeviceId = (id) => ({
  type: SET_SELECTED_DEVICE_ID,
  payload: id
});

export const getDeviceCyclePending = () => ({
  type: GET_DEVICE_CYCLE_PENDING,
});

export const setDeviceCycle = (deviceData) => ({
  type: SET_DEVICE_CYCLE,
  payload: deviceData,
});

export const deviceCycleError = (errorMessage) => ({
  type: DEVICE_CYCLE_ERROR,
  payload: { errorMessage },
});

export const getDeviceCycleSuccess = () => ({
  type: GET_DEVICE_CYCLE_SUCCESS,
});

export const getDeviceCycle = (deviceId) => (dispatch) => {
  dispatch(getDeviceCyclePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.getDeviceCycle(accessToken, deviceId)
      .then((deviceDetails) => {
        dispatch(setDeviceCycle(deviceDetails));
        dispatch(getDeviceCycleSuccess());
      })
      .catch((err) => {
        console.log("getDeviceDetails server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceCycleError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceCycleError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//-------------------------DEVICE-LOG--------------------------------------------
export const openDevicesLogModal = () => ({
  type: OPEN_DEVICE_LOG_MODAL,
});

export const closeDevicesLogModal = () => ({
  type: CLOSE_DEVICE_LOG_MODAL,
});

export const setSelectedDevice = (selectedDevice) => ({
  type: SET_SELECTED_DEVICE,
  payload: selectedDevice
});

export const getDeviceLogPending = () => ({
  type: GET_DEVICE_LOG_PENDING,
});

export const setDeviceLog = (deviceData) => ({
  type: SET_DEVICE_LOG,
  payload: deviceData,
});
export const clearDeviceLog = () => ({
  type: CLEAR_DEVICE_LOG,
});

export const deviceLogError = (errorMessage) => ({
  type: DEVICE_LOG_ERROR,
  payload: { errorMessage },
});

export const getDeviceLogSuccess = () => ({
  type: GET_DEVICE_LOG_SUCCESS,
});

export const getDeviceLogs = (deviceId) => (dispatch) => {
  dispatch(getDeviceLogPending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.getDeviceLogs(accessToken, deviceId)
      .then((deviceLogs) => {
        const sortedDeviceLogs = deviceLogs.sort((a, b) => moment(b?.actionTimeStamp).valueOf() - moment(a?.actionTimeStamp).valueOf());
        dispatch(setDeviceLog(sortedDeviceLogs));
        dispatch(getDeviceLogSuccess());
      })
      .catch((err) => {
        console.log("getDeviceDetails server error", err);
        console.log("Error response", err.response);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceLogError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceLogError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};
//-------------------------ASSIGN-DEVICE-----------------------------------------
export const openAssignDeviceModal = () => ({
  type: OPEN_ASSIGN_DEVICE_MODAL,
});

export const closeAssignDeviceModal = () => ({
  type: CLOSE_ASSIGN_DEVICE_MODAL,
});

export const assignDevicePending = () => ({
  type: ASSIGN_DEVICE_PENDING,
});

export const assignDeviceSuccess = () => ({
  type: ASSIGN_DEVICE_SUCCESS,
});

export const assignDeviceError = (errorMessage) => ({
  type: ASSIGN_DEVICE_ERROR,
  payload: { errorMessage },
});

export const clearAssignDeviceError = () => ({
  type: CLEAR_ASSIGN_DEVICE_ERROR,
});

export const setAssignDevice = (assignDevice) => ({
  type: SET_ASSIGN_DEVICE,
  payload: { assignDevice }
})

export const formatDeviceKeys = (data) => {
  var deviceKeys = [];
  if (!data) return deviceKeys;
  var rangeFields = data.split("-");
  var commaSeperated = data.split(",");

  if (rangeFields.length === 2) {
    for (var i = rangeFields[0]; i <= rangeFields[1]; i++) {
      deviceKeys.push(i.toString());
    }
  }
  else if (commaSeperated.length > 1) {
    deviceKeys = commaSeperated;
  }
  else if (Number(data)) {
    deviceKeys.push(data);
  }
  return deviceKeys;
};

export const assignDevices = () => (dispatch, getState) => {
  const currentState = getState();
  const { form, login } = currentState;
  const { formAssignDevice } = form.form;
  const { currentProfile } = login;
  const orgId = !(currentProfile.roles[0].roleKey === SUPER_ADMIN || currentProfile.roles[0].roleKey === MANUFACTURER) ? currentProfile.roles[0].orgId : formAssignDevice.new_user_organisation.value;

  if (!formAssignDevice) {
    dispatch(assignDeviceError("Please fill required details."));
    return;
  }
  const deviceKeys = formatDeviceKeys(formAssignDevice.deviceKeys);
  if (deviceKeys.length < 1) {
    dispatch(
      assignDeviceError(
        "Serial Number format is incorrect or You missed to add the serial number."
      )
    );
    return;
  }
  const assignDeviceData = {
    orgId: orgId,
    userId: formAssignDevice.selected_user && formAssignDevice.selected_user.value,
    deviceKeys: deviceKeys,
  };
  const values = trimmedValues(assignDeviceData);
  dispatch(assignDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.assignDevices(accessToken, values)
      .then((response) => {
        dispatch(clearAssignDeviceError());
        const { errors, added } = response;
        let errorMessage = "";
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');

            if (key === "invalid_serial_number") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Serial numbers ${value} are invalid. \n` : `Serial number ${value} is invalid. \n`;
            }
            else if (key === "device_key_not_assigned_to_your_org") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to your organization. \n` : `Device ${value} has not been assigned to your organization. \n`;
            }
            else if (key === "device_already_assigned") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have already been assigned. \n` : `Device ${value} has already been assigned. \n`;
            }
            else if (key === "donot_have_access") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `You don't have access to devices ${value}. \n` : `You don't have access to device ${value}. \n`;
            }
            else if (key === "donot_have_device") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to you. \n` : `Device ${value} has not been assigned to you. \n`;
            }
            else if (key === "inactive_devices") {
              errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;
            }
          });
          dispatch(assignDeviceError(errorMessage));
        }
        if (added && Object.keys(added).length !== 0) {
          Object.entries(added).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            if (key === "deviceS_ADDED_SUCCESSFULLY") {
              const message = (deviceArray && deviceArray.length) > 1 ? `${deviceArray} are assigned successfully` : `${deviceArray} is assigned successfully`;
              dispatch(showSnackbarStatus(message));
              dispatch(assignDeviceSuccess());
            }
          })
        }
        if (errors && Object.keys(errors).length === 0) {
          dispatch(closeAssignDeviceModal());
        }
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(assignDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(assignDeviceError(message));
        }
        console.log("Assign devices server error", err);
        dispatch(assignDeviceError(null));
        dispatch(closeAssignDeviceModal());
      });
  });
};


//-------------------------MASTER-DEVICE-CREATE----------------------------------------
export const openCreateMasterDeviceModal = () => ({
  type: OPEN_CREATE_MASTER_DEVICE_MODAL,
});

export const closeCreateMasterDeviceModal = () => ({
  type: CLOSE_CREATE_MASTER_DEVICE_MODAL,
});

export const createMasterDevicePending = () => ({
  type: CREATE_MASTER_DEVICE_PENDING,
});

export const createMasterDeviceSuccess = () => ({
  type: CREATE_MASTER_DEVICE_SUCCESS,
});

export const createMasterDeviceError = (errorMessage) => ({
  type: CREATE_MASTER_DEVICE_ERROR,
  payload: { errorMessage },
});

export const addMasterDeviceForm = (AddDevice) => ({
  type: ADD_MASTER_DEVICE_FORM,
  payload: { AddDevice }
})

export const clearCreateMasterDeviceError = () => ({
  type: CLEAR_CREATE_MASTER_DEVICE_ERROR,
});

export const setMasterDeviceKey = (masterDeviceKey) => ({
  type: SET_MASTER_DEVICE_KEY,
  payload: masterDeviceKey,
});

const setUnAssignedDevicesListForAsyncSelect = (devicesList, searchValue) => ({
  type: SET_UNASSIGNED_DEVICE_LIST_ASYNC,
  payload: { devicesListAsync: devicesList, searchValueAsync: searchValue },
});

const setDeviceOptions = (deviceList) => ({
  type: SET_DEVICE_LIST_OPTION,
  payload: { deviceList },
});
export const copyMasterKeyToClipboard = (masterDeviceKey) => (dispatch) => {
  if (masterDeviceKey) {
    navigator.clipboard.writeText(masterDeviceKey);
    dispatch(showSnackbarStatus("Copied"));
  } else dispatch(showSnackbarStatus("please try again."));
};

export const createMasterDeviceKey = () => (dispatch, getState) => {
  dispatch(setMasterDeviceKey(""));
  getToken(dispatch).then((accessToken) => {
    agent.Device.createMasterDeviceKey(accessToken)
      .then((masterDeviceKey) => {
        dispatch(setMasterDeviceKey(masterDeviceKey));
      })
      .catch((err) => {
        console.log("Create master device key server error", err);
        // dispatch(clearForm());
        // dispatch(closeCreateMasterDeviceModal());
        dispatch(showSnackbarStatus("Something went wrong with creating master device key. Please try again later"));
      });
  });
};

export const createMasterDevice = () => (dispatch, getState) => {
  const currentState = getState();
  const { device } = currentState;
  // const { AddDevice } = device;
  const { form } = currentState;
  const { formAddDevice } = form && form.form;
  const data = {
    ...formAddDevice.formAddDevice1,
    ...formAddDevice.formAddDevice2,
  }
  const { masterDeviceKey } = device;
  const { login } = currentState;
  const { currentProfile } = login;
  if (!data) {
    dispatch(createMasterDeviceError("Please fill required details."));
    return;
  }
  const deviceKeys = formatDeviceKeys(data.deviceKeys);
  if (data.deviceKeys && data.deviceKeys.length > 0 && data.length < 1) {
    dispatch(assignDeviceError("Serial Number format is incorrect."));
    return;
  }
  const orgId = currentProfile.roles[0].roleKey !== SUPER_ADMIN ? currentProfile.roles[0].orgId : data.new_user_organisation.value;
  const masterDeviceData = {
    friendlyName: data.friendlyName,
    orgId: orgId,
    userId: data.selected_user && data.selected_user.value,
    deviceKeys: deviceKeys,
    masterDeviceKey: data.uid,
    subscriptionValidity: data.subscriptionValidity,
    boardSerialNumber: DEFAULT_MASTER_DEVICE_SERIAL_NO,
    masterDeviceId: data && data.selected_device && data.selected_device.value,
  };
  const values = trimmedValues(masterDeviceData);
  dispatch(createMasterDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.createMasterDevice(accessToken, values)
      .then(() => {
        // dispatch(clearCreateMasterDeviceError());
        dispatch(createMasterDeviceSuccess());
        dispatch(getMasterDevicesList());
        dispatch(clearForm());
        dispatch(closeCreateMasterDeviceModal());
        dispatch(showSnackbarStatus("Master device created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createMasterDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createMasterDeviceError(message));
        }
        console.log("Create master device server error", err);
        // dispatch(clearForm());
        // dispatch(createMasterDeviceError(null));
        // dispatch(closeCreateMasterDeviceModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getUnassignedDevicesForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getUnAssignedDevices(accessToken, searchValue)
      .then((groupsList) => {
        dispatch(setDeviceOptions(groupsList))
        let groupsListOptions = modifyDevicesList(groupsList);
        if (searchValue) {
          const filteredOptions = groupsListOptions.filter((option) =>
            option?.label?.toLowerCase()?.includes(searchValue?.toLowerCase())
          );
          dispatch(setUnAssignedDevicesListForAsyncSelect(filteredOptions));
          callback && callback(filteredOptions);
        }
        else {
          dispatch(setUnAssignedDevicesListForAsyncSelect(groupsListOptions));
          callback && callback(groupsListOptions);
        }
      })
      .catch((err) => {
        console.log("getAssignable groups for dropdown server error", err);
        // dispatch(
        //   showSnackbarStatus("Something went wrong. Please try again later")
        // );
        callback && callback();
      });
  });
};

//-----------------------------MASTER DEVICE LIST-----------------------------------
export const setMasterDevicesPending = () => ({
  type: SET_MASTER_DEVICES_PENDING,
});

const masterDeviceListError = (errorMessage) => ({
  type: MASTER_DEVICES_LIST_ERROR,
  payload: { errorMessage },
});

const setMasterDevicesList = (masterDevicesOdata) => ({
  type: SET_MASTER_DEVICES_LIST,
  payload: { masterDevicesOdata },
});

export const getMasterDevicesList = (currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection) => (dispatch, getState) => {
  dispatch(setMasterDevicesPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.getMasterDevices(accessToken, currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection)
      .then((devicesList) => {
        dispatch(setMasterDevicesList(devicesList));
        Promise.resolve();
      })
      .catch((err) => {
        console.log("getMasterDevices server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(masterDeviceListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(masterDeviceListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        Promise.resolve();
      });
  });
};

export const getMasterDevicesListByCustomer = (currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection) => (dispatch, getState) => {
  dispatch(setMasterDevicesPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.getMasterDevicesListByCustomer(accessToken, currentPage, pagesize, searchUid, searchfriendlyName, searchIsActive, searchAssignedDeviceCount, searchAssignedByUserEmail, searchEndCustomerName, searchEndCustomerEmail, searchEndCustomerZone, searchEndCustomerZip, searchSubscriptionValidity, searchCreatedDateTime, sortOrder, sortDirection)
      .then((devicesList) => {
        dispatch(setMasterDevicesList(devicesList));
        Promise.resolve();
      })
      .catch((err) => {
        console.log("getMasterDevices server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(masterDeviceListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(masterDeviceListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        Promise.resolve();
      });
  });
};

export const exportMasterData = () => (dispatch, getState) => {
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.exportMasterData(accessToken)
      .then((responseData) => {
        if (responseData) {
          return Promise.resolve(responseData["value"]);
        }
      })
      .catch((err) => {
        console.log("master device data export server error", err);
      });
  });
};
export const exportMasterDataByCustomer = () => (dispatch, getState) => {
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.exportMasterDataByCustomer(accessToken)
      .then((responseData) => {
        if (responseData) {
          return Promise.resolve(responseData["value"]);
        }
      })
      .catch((err) => {
        console.log("master device data export server error", err);
      });
  });
};

//------------------TRANSFER DEVICES--------------------------------------------------
const setCurrentUserUnAssignedDevicesListForAsyncSelect = (devicesList, searchValue) => ({
  type: SET_CURRENT_USER_UNASSIGNED_DEVICE_LIST_ASYNC,
  payload: { devicesListAsync: devicesList, searchValueAsync: searchValue },
});

export const getCurrentUserUnassignedDevicesForAsyncSelect = (userId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getCurrentUserUnAssignedDevices(accessToken, userId)
      .then((deviceList) => {
        let deviceListOptions = modifyDevicesList(deviceList);
        let filteredDeviceList;
        if (searchValue) {
          filteredDeviceList = deviceListOptions && deviceListOptions.filter((device) => device && device.label && device.label.includes(searchValue))
        }
        else {
          filteredDeviceList = deviceListOptions;
        }

        dispatch(setCurrentUserUnAssignedDevicesListForAsyncSelect(filteredDeviceList));
        callback && callback(filteredDeviceList);
      })
      .catch((err) => {
        console.log("deviceListOptions for dropdown server error", err);
        callback && callback();
      });
  });
};

//------------------GROUPS & ROOMS------------------------------------------------------------
const setAssignableGroupsListForAsyncSelect = (groupsList, searchValue) => ({
  type: SET_UNASSIGNABLE_GROUPS_LIST_ASYNC,
  payload: { groupsListAsync: groupsList, searchValueAsync: searchValue },
});

export const getAssignableGroupsForAsyncSelect = (masterDeviceId, searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getAssinableGroups(accessToken, masterDeviceId)
      .then((devicesList) => {
        let devicesListOptions = modifyGroupsList(devicesList);
        dispatch(setAssignableGroupsListForAsyncSelect(devicesListOptions));
        callback && callback(devicesListOptions);
      })
      .catch((err) => {
        console.log("getUnassignedDevices for dropdown server error", err);
        // dispatch(
        //   showSnackbarStatus("Something went wrong. Please try again later")
        // );
        callback && callback();
      });
  });
};


export const getAssignableSwitchCategoryForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.getAssignableSwitchCategory(accessToken, searchValue)
      .then((categories) => {
        const categoriesList = categories && categories['value']
        let categoriesListOptions = modifyCategoryList(categoriesList);
        callback && callback(categoriesListOptions);
      })
      .catch((err) => {
        console.log("getUnassignedDevices for dropdown server error", err);
        callback && callback();
      });
  });
};

//-----------------------------DELETE DEVICE-----------------------------------
export const openDeviceDeleteConfrimationDialog = () => ({
  type: DEVICE_DELETE_CONFIRMATION_OPEN,
});

export const closeDeviceDeleteConfrimationDialog = () => ({
  type: DEVICE_DELETE_CONFIRMATION_CLOSE,
});

export const setDeviceDeleteData = (selectedDevice) => ({
  type: SET_DEVICE_DELETE_DATA,
  payload: { selectedDevice }
});

export const clearDeviceDeleteError = () => ({
  type: CLEAR__DEVICE_DELETE_ERROR,
});

export const setDeviceDeletePending = () => ({
  type: SET_DEVICE_DELETE_PENDING,
});

export const deviceDeleteError = (errorMessage) => ({
  type: DEVICE_DELETE_ERROR,
  payload: { errorMessage },
});

export const deleteDevice = (devices) => (dispatch) => {
  dispatch(setDeviceDeletePending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.deleteDevice(accessToken, devices)
      .then((response) => {
        dispatch(clearDeviceDeleteError());
        dispatch(closeDeviceDeleteConfrimationDialog());
        //dispatch(getDevicesList());
        const { errors, deleted } = response;
        let errorMessage = "";
        let deletedDeviceArr;
        if (errors && Object.keys(errors).length !== 0) {
          Object.entries(errors).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            switch (key) {
              case "invalid_serial_number":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Device key ${value} are invalid. \n` : `Device key ${value} is invalid. \n`;

              case "device_key_not_assigned_to_your_org":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to your organization. \n` : `Device ${value} has not been assigned to your organization. \n`;

              case "device_key_assigned_as_master_device":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned as master devices. \n` : `Device ${value} has been assigned as master device. \n`;

              case "device_key_assigned_to_customer":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to customer. \n` : `Device ${value} has been assigned to customer. \n`;

              case "device_already_assigned":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to someone. \n` : `Device ${value} has been assigned to someone. \n`;

              case "device_key_assigned_to_others":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to someone. \n` : `Device ${value} has been assigned to someone. \n`;

              case "donot_have_access":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;

              case "donot_have_device":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are invalid. \n` : `Device ${value} is invalid. \n`;

              case "user_not_assigned_to_your_org":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have not been assigned to your organization's users. \n` : `Device ${value} has not been assigned to your organization's users. \n`;

              case "user_already_assigned":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} have been assigned to someone. \n` : `Device ${value} has been assigned to someone. \n`;

              case "device_key_not_inactive":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are inactive. \n` : `Device ${value} is inactive. \n`;

              case "already_deleted":
                return errorMessage += (deviceArray && deviceArray.length) > 1 ? `Devices ${value} are already deleted. \n` : `Device ${value} is already deleted. \n`;

              default:
                return errorMessage += "Something went wrong. Try again later.";
            }
          });
          dispatch(deviceDeleteError(errorMessage));
        }
        if (deleted && Object.keys(deleted).length !== 0) {
          Object.entries(deleted).forEach((obj) => {
            const [key, value] = obj;
            const deviceArray = value && value.split(',');
            if (key === "deviceS_DELETED_SUCCESSFULLY") {
              const message = (deviceArray && deviceArray.length) > 1 ? `${deviceArray} are deleted successfully` : `${deviceArray} is deleted successfully`;
              deletedDeviceArr = deviceArray;
              dispatch(showSnackbarStatus(message));
            }
          })
        }
        return Promise.resolve({ isDeviceDeleted: Object.keys(errors).length === 0, deletedDevices: deletedDeviceArr })
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceDeleteError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceDeleteError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};